const cashflowProgressionData = [
  {
    month: ["2021", "Aug"],
    totalRevenue: 1056302.74,
    preMarketingEbitda: 605038.99,
    netIncome: -273191.15,
    grossMargin: 605038.99,
    changeInCash: null,
    ebitda: -261682.45,
  },
  {
    month: ["2021", "Sep"],
    totalRevenue: 829310.85,
    preMarketingEbitda: 415743.79,
    netIncome: -785783.29,
    grossMargin: 415743.79,
    changeInCash: -453558.47,
    ebitda: -710855.77,
  },
  {
    month: ["2021", "Oct"],
    totalRevenue: 2061491.35,
    preMarketingEbitda: 1222946.13,
    netIncome: 19219.22,
    grossMargin: 1222946.13,
    changeInCash: 417874.0,
    ebitda: 29210.15,
  },
  {
    month: ["2021", "Nov"],
    totalRevenue: 3116471.59,
    preMarketingEbitda: 1849843.97,
    netIncome: 183403.63,
    grossMargin: 1849843.97,
    changeInCash: 652045.14,
    ebitda: 223837.94,
  },
  {
    month: ["2021", "Dec"],
    totalRevenue: 3247412.49,
    preMarketingEbitda: 1838581.56,
    netIncome: -136687.84,
    grossMargin: 1838581.56,
    changeInCash: 640287.72,
    ebitda: -133300.42,
  },
  {
    month: ["2022", "Jan"],
    totalRevenue: 1225423.81,
    preMarketingEbitda: 541221.17,
    netIncome: -497343.3,
    grossMargin: 541221.17,
    changeInCash: -1128173.65,
    ebitda: -496804.59,
  },
  {
    month: ["2022", "Feb"],
    totalRevenue: 1488528.38,
    preMarketingEbitda: 882590.77,
    netIncome: -373991.93,
    grossMargin: 882590.77,
    changeInCash: 406667.77,
    ebitda: -334126.64,
  },
  {
    month: ["2022", "Mar"],
    totalRevenue: 1370241.74,
    preMarketingEbitda: 758729.43,
    netIncome: -228664.15,
    grossMargin: 758729.43,
    changeInCash: -1022479.46,
    ebitda: -227476.2,
  },
  {
    month: ["2022", "Apr"],
    totalRevenue: 997813.92,
    preMarketingEbitda: 504036.65,
    netIncome: -475392.37,
    grossMargin: 504036.65,
    changeInCash: 71744.72,
    ebitda: -474566.67,
  },
  {
    month: ["2022", "May"],
    totalRevenue: 1276291.23,
    preMarketingEbitda: 751475.78,
    netIncome: -279666.88,
    grossMargin: 751475.78,
    changeInCash: -301513.97,
    ebitda: -283093.72,
  },
  {
    month: ["2022", "Jun"],
    totalRevenue: 1147775.8,
    preMarketingEbitda: 620542.55,
    netIncome: -329005.7,
    grossMargin: 620542.55,
    changeInCash: 293203.58,
    ebitda: -328131.99,
  },
  {
    month: ["2022", "Jul"],
    totalRevenue: 968255.47,
    preMarketingEbitda: 490408.33,
    netIncome: -426311.31,
    grossMargin: 490408.33,
    changeInCash: 83765.02,
    ebitda: -426064.94,
  },
  {
    month: ["2022", "Aug"],
    totalRevenue: 1460722.01,
    preMarketingEbitda: 733338.54,
    netIncome: -237128.85,
    grossMargin: 733338.54,
    changeInCash: -197195.88,
    ebitda: -231432.52,
  },
  {
    month: ["2022", "Sep"],
    totalRevenue: 903691.02,
    preMarketingEbitda: 434959.17,
    netIncome: -918755.5,
    grossMargin: 434959.17,
    changeInCash: -154959.43,
    ebitda: -908612.45,
  },
  {
    month: ["2022", "Oct"],
    totalRevenue: 2572904.85,
    preMarketingEbitda: 1607418.18,
    netIncome: -65070.41,
    grossMargin: 1607418.18,
    changeInCash: 367380.38,
    ebitda: -41330.69,
  },
  {
    month: ["2022", "Nov"],
    totalRevenue: 4061811.53,
    preMarketingEbitda: 2545935.17,
    netIncome: 985749.74,
    grossMargin: 2545935.17,
    changeInCash: 988236.31,
    ebitda: 996662.53,
  },
  {
    month: ["2022", "Dec"],
    totalRevenue: 3473715.02,
    preMarketingEbitda: 1971616.57,
    netIncome: 681418.64,
    grossMargin: 1971616.57,
    changeInCash: -723991.6,
    ebitda: 915443.82,
  },
  {
    month: ["2023", "Jan"],
    totalRevenue: 1457363.91,
    preMarketingEbitda: 720973.17,
    netIncome: -411500.42,
    grossMargin: 720973.17,
    changeInCash: 720610.92,
    ebitda: -408923.78,
  },
  {
    month: ["2023", "Feb"],
    totalRevenue: 651704.91,
    preMarketingEbitda: 362867.12,
    netIncome: -441732.46,
    grossMargin: 362867.12,
    changeInCash: -1461012.22,
    ebitda: -437982.85,
  },
  {
    month: ["2023", "Mar"],
    totalRevenue: 1064881.14,
    preMarketingEbitda: 620772.96,
    netIncome: -271961.64,
    grossMargin: 620772.96,
    changeInCash: 294352.66,
    ebitda: -268249.95,
  },
  {
    month: ["2023", "Apr"],
    totalRevenue: 644017.64,
    preMarketingEbitda: 362507.38,
    netIncome: -365535.63,
    grossMargin: 362507.38,
    changeInCash: 504545.84,
    ebitda: -362322.35,
  },
  {
    month: ["2023", "May"],
    totalRevenue: 970982.72,
    preMarketingEbitda: 567370.78,
    netIncome: -142220.96,
    grossMargin: 567370.78,
    changeInCash: 354893.05,
    ebitda: -138217.53,
  },
  {
    month: ["2023", "Jun"],
    totalRevenue: 669718.47,
    preMarketingEbitda: 356721.22,
    netIncome: -114420.61,
    grossMargin: 356721.22,
    changeInCash: -335778.22,
    ebitda: -110445.3,
  },
  {
    month: ["2023", "Jul"],
    totalRevenue: 744590.0,
    preMarketingEbitda: 364889.98,
    netIncome: -266180.87,
    grossMargin: 364889.98,
    changeInCash: -287826.69,
    ebitda: -261339.09,
  },
  {
    month: ["2023", "Aug"],
    totalRevenue: 1461633.43,
    preMarketingEbitda: 860538.95,
    netIncome: 411625.34,
    grossMargin: 860538.95,
    changeInCash: 485297.33,
    ebitda: 478974.27,
  },
  {
    month: ["2023", "Sep"],
    totalRevenue: 1148165.85,
    preMarketingEbitda: 647090.12,
    netIncome: -334490.93,
    grossMargin: 647090.12,
    changeInCash: -821919.25,
    ebitda: -330344.04,
  },
  {
    month: ["2023", "Oct"],
    totalRevenue: 2708776.66,
    preMarketingEbitda: 1758525.62,
    netIncome: 167077.65,
    grossMargin: 1758525.62,
    changeInCash: 948370.82,
    ebitda: 214908.24,
  },
  {
    month: ["2023", "Nov"],
    totalRevenue: 4042095.01,
    preMarketingEbitda: 2573849.95,
    netIncome: 1042431.01,
    grossMargin: 2573849.95,
    changeInCash: 1576214.73,
    ebitda: 1047403.41,
  },
  {
    month: ["2023", "Dec"],
    totalRevenue: 3560257.66,
    preMarketingEbitda: 2127809.68,
    netIncome: 590468.22,
    grossMargin: 2127809.68,
    changeInCash: -130778.35,
    ebitda: 1142678.98,
  },
  {
    month: ["2024", "Jan"],
    totalRevenue: 1357548.17,
    preMarketingEbitda: 704527.9,
    netIncome: -290893.13,
    grossMargin: 704527.9,
    changeInCash: -485095.61,
    ebitda: -288098.75,
  },
  {
    month: ["2024", "Feb"],
    totalRevenue: 1412332.92,
    preMarketingEbitda: 852442.72,
    netIncome: -110915.23,
    grossMargin: 852442.72,
    changeInCash: -573182.36,
    ebitda: -27314.47,
  },
  {
    month: ["2024", "Mar"],
    totalRevenue: 1109826.56,
    preMarketingEbitda: 666606.51,
    netIncome: -135135.46,
    grossMargin: 666606.51,
    changeInCash: -343101.34,
    ebitda: -130093.38,
  },
  {
    month: ["2024", "Apr"],
    totalRevenue: 854810.07,
    preMarketingEbitda: 491998.35,
    netIncome: -231830.41,
    grossMargin: 491998.35,
    changeInCash: -802425.46,
    ebitda: -227585.66,
  },
  {
    month: ["2024", "May"],
    totalRevenue: 1304298.49,
    preMarketingEbitda: 739394.2,
    netIncome: 41031.37,
    grossMargin: 739394.2,
    changeInCash: 1338934.08,
    ebitda: 128549.29,
  },
  {
    month: ["2024", "Jun"],
    totalRevenue: 778806.57,
    preMarketingEbitda: 423225.13,
    netIncome: -159555.36,
    grossMargin: 423225.13,
    changeInCash: -432900.59,
    ebitda: -145428.41,
  },
  {
    month: ["2024", "Jul"],
    totalRevenue: 819763.32,
    preMarketingEbitda: 391749.68,
    netIncome: -532894.18,
    grossMargin: 391749.68,
    changeInCash: -868762.11,
    ebitda: -528576.95,
  },
  {
    month: ["2024", "Aug"],
    totalRevenue: 1212828.82,
    preMarketingEbitda: 715214.82,
    netIncome: 15554.2,
    grossMargin: 715214.82,
    changeInCash: 58709.93,
    ebitda: 22798.87,
  },
  {
    month: ["2024", "Sep"],
    totalRevenue: 1310645.84,
    preMarketingEbitda: 735601.58,
    netIncome: -483634.18,
    grossMargin: 735601.58,
    changeInCash: -40804.14,
    ebitda: -302181.54,
  },
  {
    month: ["2024", "Oct"],
    totalRevenue: 1992038.87,
    preMarketingEbitda: 1254771.22,
    netIncome: -163893.01,
    grossMargin: 1254771.22,
    changeInCash: 505718.7,
    ebitda: -166876.94,
  },
  {
    month: ["2024", "Nov"],
    totalRevenue: 3168315.18,
    preMarketingEbitda: 1989808.77,
    netIncome: 823853.55,
    grossMargin: 1989808.77,
    changeInCash: 716069.69,
    ebitda: 904849.13,
  },
  {
    month: ["2024", "Dec"],
    totalRevenue: 4392768.15,
    preMarketingEbitda: 2620464.6,
    netIncome: 110135.69,
    grossMargin: 2620464.6,
    changeInCash: 878675.19,
    ebitda: 689865.96,
  },
  {
    month: ["2025", "Jan"],
    totalRevenue: 1200761.65,
    preMarketingEbitda: 616446.92,
    netIncome: -543147.23,
    grossMargin: 616446.92,
    changeInCash: -990942.94,
    ebitda: -542199.64,
  },
  {
    month: ["2025", "Feb"],
    totalRevenue: 1364382.34,
    preMarketingEbitda: 807910.29,
    netIncome: -49217.81,
    grossMargin: 807910.29,
    changeInCash: 63553.72,
    ebitda: -44694.79,
  },
  {
    month: ["2025", "Mar"],
    totalRevenue: 1520812.98,
    preMarketingEbitda: 953225.48,
    netIncome: 105697.53,
    grossMargin: 953225.48,
    changeInCash: 807792.91,
    ebitda: 112243.9,
  },
  {
    month: ["2025", "Apr"],
    totalRevenue: 725728.68,
    preMarketingEbitda: 384629.32,
    netIncome: -419946.7,
    grossMargin: 384629.32,
    changeInCash: -751169.17,
    ebitda: -415232.58,
  },
  {
    month: ["2025", "May"],
    totalRevenue: 1109996.95,
    preMarketingEbitda: 668277.06,
    netIncome: -112206.39,
    grossMargin: 668277.06,
    changeInCash: 49779.59,
    ebitda: -108584.43,
  },
  {
    month: ["2025", "Jun"],
    totalRevenue: 765991.16,
    preMarketingEbitda: 437507.34,
    netIncome: 375209.2,
    grossMargin: 437507.34,
    changeInCash: -92974.35,
    ebitda: 381408.26,
  },
  {
    month: ["2025", "Jul"],
    totalRevenue: 37494.53,
    preMarketingEbitda: 23722.46,
    netIncome: 21769.13,
    grossMargin: 23722.46,
    changeInCash: 23301.51,
    ebitda: 21769.13,
  },
];

export default cashflowProgressionData;
